<template>
  <div class="spacer-top-big">
    <!-- Small centered column -->
    <b-col offset-lg="3" lg="6">
      <!-- Form -->
      <b-form>
        <!-- Card -->
        <b-card class="card-small card-regform">
          <!-- Header Card -->
          <div slot="header" class="text-center">
            <img src="@/assets/img/logo_nedgia.png" class="form-logo">
            <h1 class="form-headertext" style="color:#004072">{{title}}</h1>
          </div>
          <slot></slot>
          <!-- Header Card END -->
          <div slot="footer" class="text-center">
          </div>
        </b-card>
        <!-- Main Card END -->
      </b-form>
      <!-- Form END -->
    </b-col>
    <!-- Small centered column END -->
  </div>
</template>

<script>
export default {
  name: 'MainLogin',
  props: ['title']
};
</script>




// WEBPACK FOOTER //
// src/components/Pages/Login/MainLogin.vue